module.exports = __webpack_public_path__ + "img/sample_avatar.9909caa3.jpg";